const ROLE_ALIASES = {
  administrator: "admin",
  "school admin": "admin",
  "it admin": "it",
  itadmin: "it",
  "it person": "it",
  "vice principal": "principal",
  viceprincipal: "principal",
};

export const PERMISSIONS = {
  ADMIN_DASHBOARD: "admin_dashboard",
  STUDENT_ONBOARDING: "student_onboarding",
  STUDENT_QR_MANAGER: "student_qr_manager",
  MANAGE_CIRCULARS: "manage_circulars",
  CREATE_EVENTS: "create_events",
  MANAGE_EVENTS: "manage_events",
  MANAGE_NOTICES: "manage_notices",
  VIEW_PAYMENTS: "view_payments",
};

const PERMISSION_ROLES = {
  [PERMISSIONS.ADMIN_DASHBOARD]: ["admin", "it", "principal"],
  [PERMISSIONS.STUDENT_ONBOARDING]: ["admin", "it", "principal"],
  [PERMISSIONS.STUDENT_QR_MANAGER]: ["admin", "it", "principal"],
  [PERMISSIONS.MANAGE_CIRCULARS]: ["admin", "it", "principal"],
  [PERMISSIONS.CREATE_EVENTS]: ["admin", "it", "principal", "teacher"],
  [PERMISSIONS.MANAGE_EVENTS]: ["admin"],
  [PERMISSIONS.MANAGE_NOTICES]: ["admin", "it", "principal"],
  [PERMISSIONS.VIEW_PAYMENTS]: ["admin", "principal"],
};

const DASHBOARD_ROLE_PRIORITY = ["admin", "principal", "it", "teacher"];

const DASHBOARD_LABELS = {
  admin: "Admin Dashboard",
  it: "IT Dashboard",
  principal: "Principal Dashboard",
  teacher: "Teacher Dashboard",
};

const DASHBOARD_PATHS = {
  admin: "/admin-dashboard",
  it: "/admin-dashboard",
  principal: "/admin-dashboard",
  teacher: "/teacher-dashboard",
};

export const SUPPORTED_USER_ROLES = [
  "admin",
  "it",
  "principal",
  "teacher",
  "parent",
  "conductor",
];

export function normalizeRoleName(role) {
  const cleaned = String(role || "")
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/-/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (!cleaned) {
    return "";
  }

  return ROLE_ALIASES[cleaned] || cleaned;
}

function collectRoles(rawRoles) {
  if (Array.isArray(rawRoles)) {
    return rawRoles;
  }

  if (typeof rawRoles === "string") {
    return rawRoles.split(",");
  }

  return [];
}

export function getUserRoles(userData = {}) {
  const candidateRoles = [
    ...collectRoles(userData.roles),
    ...collectRoles(userData.role),
  ];

  return [...new Set(candidateRoles.map(normalizeRoleName).filter(Boolean))];
}

export function hasPermission(userData, permission) {
  const allowedRoles = PERMISSION_ROLES[permission];

  if (!Array.isArray(allowedRoles) || allowedRoles.length === 0) {
    return false;
  }

  const normalizedRoles = getUserRoles(userData);
  return normalizedRoles.some((role) => allowedRoles.includes(role));
}

export function getAllowedRoles(permission) {
  return PERMISSION_ROLES[permission] || [];
}

export function getDashboardRole(userData = {}) {
  const roles = getUserRoles(userData);

  return DASHBOARD_ROLE_PRIORITY.find((role) => roles.includes(role)) || null;
}

export function getDashboardLabel(userData = {}) {
  const dashboardRole = getDashboardRole(userData);

  if (!dashboardRole) {
    return "Dashboard";
  }

  return DASHBOARD_LABELS[dashboardRole] || "Dashboard";
}

export function getDashboardPath(userData = {}) {
  const dashboardRole = getDashboardRole(userData);

  if (!dashboardRole) {
    return null;
  }

  return DASHBOARD_PATHS[dashboardRole] || null;
}

export function getDashboardConfig(userData = {}) {
  const dashboardRole = getDashboardRole(userData);

  if (!dashboardRole) {
    return null;
  }

  return {
    role: dashboardRole,
    label: getDashboardLabel(userData),
    path: getDashboardPath(userData),
  };
}
